import formSportsRoomBlackoutsContent from './formSportsRoomBlackoutsContent';
import formSportsRoomContent from './formSportsRoomContent';
import formSportsRoomContentAPIs from './formSportsRoomContentAPIs';
import formSportsRoomExtraComponents from './formSportsRoomExtraComponents';
import formSportsRoomMinigames from './formSportsRoomMinigames';
import formSportsRoomTeamsToCameraContent from './formSportsRoomTeamsToCameraContent';

export default {
  title: 'Content Form',
  attributeName: 'appLayoutForm',
  getURL: 'appId/areaId/appContentSportsRoom',
  createURL: 'appId/areaId/appContentSportsRoom',
  updateURL: 'appId/areaId/appContentSportsRoom',
  additionaMetadataURL: 'appId/additionalMetadata/AppContent',
  newURL: 'appId/areaId/appContentSportsRoom/defaults',
  autoUpdate: false,
  idUpdate:true,
  removeURL: '',
  idAttribute: 'id',
  sessionParams: ['appId', 'areaId'],
  updateReduxWhen:['appTeams','teamsToCameraContentTable','teams','composeExperienceObj'],
  formConfig: [formSportsRoomContent,formSportsRoomMinigames,formSportsRoomExtraComponents,formSportsRoomTeamsToCameraContent,formSportsRoomBlackoutsContent,formSportsRoomContentAPIs],
  noArea: false,
  disableArea:true,
  showOperatingSystem:true,
  goBack: true,
};
